// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentVerifySurveyEntryResultModel {
    static getAttributeTypeMap() {
        return EnrollmentVerifySurveyEntryResultModel.attributeTypeMap;
    }
}
EnrollmentVerifySurveyEntryResultModel.discriminator = undefined;
EnrollmentVerifySurveyEntryResultModel.additionalProperties = false;
EnrollmentVerifySurveyEntryResultModel.attributeTypeMap = [
    {
        "name": "isEligible",
        "baseName": "isEligible",
        "type": "boolean"
    },
];
//# sourceMappingURL=enrollmentVerifySurveyEntryResultModel.js.map